"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateFullAdsetResponseToJSON = exports.CreateFullAdsetResponseFromJSONTyped = exports.CreateFullAdsetResponseFromJSON = exports.instanceOfCreateFullAdsetResponse = void 0;
var runtime_1 = require("../runtime");
var AdResponse_1 = require("./AdResponse");
var AdSetResponse_1 = require("./AdSetResponse");
/**
 * Check if a given object implements the CreateFullAdsetResponse interface.
 */
function instanceOfCreateFullAdsetResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCreateFullAdsetResponse = instanceOfCreateFullAdsetResponse;
function CreateFullAdsetResponseFromJSON(json) {
    return CreateFullAdsetResponseFromJSONTyped(json, false);
}
exports.CreateFullAdsetResponseFromJSON = CreateFullAdsetResponseFromJSON;
function CreateFullAdsetResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adSet': !(0, runtime_1.exists)(json, 'ad_set') ? undefined : (0, AdSetResponse_1.AdSetResponseFromJSON)(json['ad_set']),
        'ads': !(0, runtime_1.exists)(json, 'ads') ? undefined : (json['ads'].map(AdResponse_1.AdResponseFromJSON)),
    };
}
exports.CreateFullAdsetResponseFromJSONTyped = CreateFullAdsetResponseFromJSONTyped;
function CreateFullAdsetResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ad_set': (0, AdSetResponse_1.AdSetResponseToJSON)(value.adSet),
        'ads': value.ads === undefined ? undefined : (value.ads.map(AdResponse_1.AdResponseToJSON)),
    };
}
exports.CreateFullAdsetResponseToJSON = CreateFullAdsetResponseToJSON;
